import { type FC, type ReactNode, useEffect } from "react";
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from "react-router-dom";

import SentryClient from "@snapchat/sentry-browser";
// eslint-disable-next-line import/order -- https://docs.sentry.io/platforms/javascript/performance/instrumentation/automatic-instrumentation/#enable-instrumentation
import { BrowserTracing, reactRouterV6Instrumentation } from "@sentry/react";

import { BUILD_TYPE, DOMAIN, SENTRY_DSN, VERSION, isLocal, isProdLike } from "../shared/constants";

import { ignoredErrors } from "./constants";

export const Sentry: FC<{ children?: ReactNode }> = ({ children }) => {
    useEffect(() => {
        if (!VERSION) {
            console.warn("WARNING: Sentry not initialized, missing VERSION");
            return;
        }

        const urls = [/localhost/, /^\//, new RegExp(DOMAIN)];

        SentryClient.init({
            debug: !isProdLike(),
            enabled: !isLocal(),
            dsn: SENTRY_DSN,
            release: VERSION,
            environment: BUILD_TYPE,
            allowUrls: urls,
            normalizeDepth: 8,
            normalizeMaxBreadth: 50,
            integrations: [
                new BrowserTracing({
                    routingInstrumentation: reactRouterV6Instrumentation(
                        useEffect,
                        useLocation,
                        useNavigationType,
                        createRoutesFromChildren,
                        matchRoutes,
                    ),
                }),
            ],
            tracePropagationTargets: urls,
            tracesSampleRate: 1,
            ignoreErrors: ignoredErrors,
        });
    }, []);

    return <>{children}</>;
};
